import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useEffect } from 'react'
import ThemeForm, { IThemeFormValues } from 'app-support/themes/components/ThemeForm'
import { getTheme, resetTheme, updateTheme } from 'app-support/themes/state/actions'
import { generateSubmissionError } from 'utils-support/Form/SubmissionError'
import { IRootReducerState } from 'state/reducers'
import { useTranslation } from 'react-i18next'
import { useNotifier } from '@cbgms/base/notifier'

const EditThemeForm = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const notifier = useNotifier()
  const theme = useSelector((state: IRootReducerState) => state.theme)
  const { ThemeUUID } = useParams<{ ThemeUUID?: string }>()

  useEffect(() => {
    if (ThemeUUID) {
      dispatch(getTheme(ThemeUUID))
    }

    return () => {
      dispatch(resetTheme())
    }
  }, [ThemeUUID])

  const onSubmit = async (values: IThemeFormValues) => {
    try {
      if (!values.UUID) return values
      dispatch(updateTheme(values.UUID, values))
    } catch (error) {
      throw generateSubmissionError(error)
    }

    return values
  }

  const onSubmitAndDone = async (values: IThemeFormValues) => {
    onSubmit(values)
  }

  const onSubmitSuccess = async () => {
    notifier.success(t('theme.updated_successfully'))
  }

  if (!theme) {
    return null
  }

  return (
    <ThemeForm
      initialValues={theme}
      onSubmit={onSubmit}
      onSubmitAndDone={onSubmitAndDone}
      onSubmitSuccess={onSubmitSuccess}
      redirectToURL='/themes'
      title={t('theme.general_tab')}
      confirmationRequired
    />
  )
}

export default EditThemeForm
